<template>
    <td-dialog :title="$t(title)" :before-close="dialogConsumerClose" :visible.sync="dialogVisible" width="320px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="fromConsumerInfo" :label-width="formLabelWidth" ref="fromConsumerInfo" :rules="rules">
            <el-form-item :label="$t('common.CONSUMER')" prop="sConsumer">
                <td-select v-model="fromConsumerInfo.sConsumer" :options="optionsConsumer"></td-select>
            </el-form-item>
            <el-form-item :label="$t('common.REQUEST_MODE')" prop="iType">
                <td-select v-model="fromConsumerInfo.iType" :options="optionsType"></td-select>
            </el-form-item>
            <el-form-item :label="$t('common.REQUEST_URL')" prop="sURL">
                <td-input v-model="fromConsumerInfo.sURL" maxlength="50"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="loading" @click="submitForm('fromConsumerInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="dialogConsumerClose" :disabled="cancelDisable">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import thirdPartyApi from '../assets/api.js';
export default {
    props: ['title', 'dialogVisible', 'editItem', 'isAddData', 'listConsumerInfo'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        } else {
            if (this.listConsumerInfo !== null && this.listConsumerInfo.length > 0) {
                this.fromConsumerInfo.sConsumer = this.listConsumerInfo[0].value;
            }
        }
    },
    // 定义变量
    data() {
        return {
            // 表单信息
            fromConsumerInfo: {
                sConsumer: '',
                iType: '1',
                sURL: ''
            },
            // 方式类型类型转换
            optionsType: [
                {
                    value: '1',
                    label: this.$t('common.WEB_SERVICE')
                }
            ],
            // 消费者下拉框
            optionsConsumer: this.listConsumerInfo,
            loading: false,
            cancelDisable: false,
            formLabelWidth: '80px',
            // 对表单进行数据验证
            rules: {
                sConsumer: [{ required: true, message: this.$t('error.ERROR_INPUT_CONSUMER'), trigger: 'change' }],
                iType: [{ required: true, message: this.$t('error.ERROR_INPUT_REQUEST_MODE'), trigger: 'change' }],
                sURL: [{ required: true, message: this.$t('error.ERROR_INPUT_URL'), trigger: 'blur' }, { pattern: this.$regex.URL_RULE, message: this.$t('error.ERROR_URL_ILLEGAL') }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.fromConsumerInfo.sConsumer = this.editItem.sSrcId;
            this.fromConsumerInfo.iType = String(this.editItem.iType);
            this.fromConsumerInfo.sURL = this.editItem.sURL;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.cancelDisable = true;
                    let content = {
                        sSrcId: this.fromConsumerInfo.sConsumer,
                        iType: this.fromConsumerInfo.iType,
                        sURL: this.fromConsumerInfo.sURL
                    };
                    if (this.isAddData) {
                        thirdPartyApi.insertThirdPartyInfo(JSON.stringify(content), response => {
                            this.loading = false;
                            this.cancelDisable = false;
                            if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dialogConsumerInfo/insertThirdPartyInfo', response.data.statusMessage);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                            this.$emit('submit');
                            this.dialogConsumerClose();
                        });
                    } else {
                        content.sid = this.editItem.sId;
                        thirdPartyApi.updateThirdPartyInfo(JSON.stringify(content), response => {
                            this.loading = false;
                            if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dialogConsumerInfo/updateThirdPartyInfo', response.data.statusMessage);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                            this.$emit('submit');
                            this.dialogConsumerClose();
                        });
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        dialogConsumerClose() {
            this.$emit('dialogConsumerClose');
            this.$refs['fromConsumerInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
